import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-join-nuagedx-network',
    templateUrl: './join-nuagedx-network.component.html',
    styleUrls: ['./join-nuagedx-network.component.scss'],
    standalone: false
})
export class JoinNuageDxNetworkComponent {
  constructor(
    public dialogRef: MatDialogRef<JoinNuageDxNetworkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
